import BLACK_BUS from 'assets/images/markers/bus_black.png';
import YELLOW_BUS from 'assets/images/markers/bus_yellow.png';
import PRIMARY_DBD from 'assets/images/markers/dbd_primary.png';
import YELLOW_DBD from 'assets/images/markers/dbd_yellow.png';
import DEFAULT_PRIMARY from 'assets/images/markers/default_primary.png';
import DEFAULT_YELLOW from 'assets/images/markers/default_yellow.png';
import BULL from 'assets/images/markers/bull.svg';
import PURCHASE from 'assets/images/icons/map_icons/purchaseIcon.svg';
import BOARDING from 'assets/images/icons/map_icons/boardingIcon.svg';
import LANDING from 'assets/images/icons/map_icons/landingIcon.svg';
import BLACK_POINT from 'assets/images/icons/map_icons/blackPoint.svg';
import SELLING_TERMINAL_POINT from 'assets/images/icons/map_icons/sellingTerminalPoint.svg';

export default {
  MARKERS_URLS: {
    RED: 'http://maps.google.com/mapfiles/ms/icons/red.png',
    GREY: 'http://maps.google.com/mapfiles/ms/icons/grey.png',
    BLUE: 'http://maps.google.com/mapfiles/ms/icons/blue.png',
    GREEN: 'http://maps.google.com/mapfiles/ms/icons/green.png',
    PURPLE: 'http://maps.google.com/mapfiles/ms/icons/purple.png',
    YELLOW: 'http://maps.google.com/mapfiles/ms/icons/yellow.png',

    BLACK_BUS,
    YELLOW_BUS,
    PRIMARY_DBD,
    YELLOW_DBD,
    DEFAULT_PRIMARY,
    DEFAULT_YELLOW,
    BULL,
    PURCHASE,
    BOARDING,
    LANDING,
    BLACK_POINT,
    SELLING_TERMINAL_POINT,
  },
  // BOUNDING BOX BRAZIL
  BOUNDING_BOX_BRAZIL: 'bbox:-75.621096,-35.535078,-33.433596,7.645521',
  DEFAULT_CENTER: [-14.2426865, -51.3061292],
  // Leaflet only
  CONTRIBUTION_ICON: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  CONTRIBUTION_LINK:
    '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};
